import { Image } from '@dtx-company/shared-components/src/components/atoms/Image/index'
import { Stack, Typography, theme } from '@dtx-company/design-system/src'
import { getDefaultPaymentMethodMainText } from '@app/common/src/components/PlanPurchaseExperience/components/GetDefaultPaymentMethodMainText'
import {
  getPaymentMethodImageAlt,
  getPaymentMethodImageSrc
} from '@app/common/src/components/PlanPurchaseExperience/components/PaymentMethodDisplay'
import { useBuyPlanPageContext } from '../../context/useBuyPlanPageContext'
import React from 'react'
import styled from 'styled-components'

const _ExistingCreditCardImage = styled(Image)`
  flex: 0 0 auto;
`

export const BuyPlanPageExistingPaymentMethod: React.FC = () => {
  const { existingPaymentMethod } = useBuyPlanPageContext()
  if (!existingPaymentMethod) return null

  const imageSrc = getPaymentMethodImageSrc(existingPaymentMethod)
  const mainText = getDefaultPaymentMethodMainText(existingPaymentMethod, 'buyPlan')
  const imageAlt = getPaymentMethodImageAlt(existingPaymentMethod)

  return (
    <Stack direction="row" spacing={2} sx={{ mt: theme.spacing(6) }}>
      {imageSrc && (
        <_ExistingCreditCardImage src={imageSrc} width={38} height={23} alt={imageAlt} />
      )}
      {mainText && <Typography variant="bodyMedium">{mainText}</Typography>}
    </Stack>
  )
}
